import React from 'react';
import {
  Box,
  Typography,
  Card,
  CardContent,
  Button
} from '@mui/material';
import {
  CalendarToday as CalendarIcon
} from '@mui/icons-material';
import { useTranslation } from '../../hooks/useTranslation';

const BookingSection = ({ onBooking, isMobile = false }) => {
  const { t } = useTranslation();
  if (!isMobile) {
    return null; // Only show on mobile
  }

  return (
    <Card sx={{ mt: 3, borderRadius: 2, border: '1px solid #E5E7EB' }}>
      <CardContent sx={{ p: 3, textAlign: 'center' }}>
        <Typography variant="h6" sx={{ mb: 2, fontWeight: 600, color: '#000000' }}>
          {t('salon.makeAppointment')}
        </Typography>
        
        <Typography variant="body2" sx={{ color: '#6B7280', mb: 3, lineHeight: 1.5 }}>
          {t('salon.bookEasily')}
        </Typography>
        
        <Button
          fullWidth
          variant="contained"
          size="large"
          startIcon={<CalendarIcon />}
          onClick={onBooking}
          sx={{
            backgroundColor: '#000000',
            color: '#FFFFFF',
            borderRadius: 2,
            py: 1.5,
            fontWeight: 600,
            '&:hover': {
              backgroundColor: '#1F1F1F'
            }
          }}
        >
          {t('salon.chooseSlot')}
        </Button>
      </CardContent>
    </Card>
  );
};

export default BookingSection;